<template>
    <div>
        <card-header title='New Registration Question' icon="fa-plus"/>

        <card-body>
            <conf-question-form :question="newQuestion"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!newQuestion.type || !newQuestion.title"
                    ><i class="fas fa-plus mr-2"></i>New Registration Question</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import {client as http} from "@/http_client";
    import RmcQuestionForm from "./QuestionForm";
    import ConfQuestionForm from "./QuestionForm";

    export default {
        components: {ConfQuestionForm, RmcQuestionForm, CardHeader, CardToolbar, CardBody, CardFooter},
        props: ['card', 'props'],
        data() {
            return {
                newQuestion: {
                    options: []
                }
            }
        },
        methods: {
            submit: function() {
                this.$emit('loading', true);
                http.post('conferences/' + this.props.confId + '/questions', {...this.newQuestion, conference_id: this.props.confId}, {force: true}).then(response => {
                    this.$reloadCard('conf-questions', {confId: this.props.confId});
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the conference question.');
                    this.$emit('loading', false);
                });
            }
        }
    }
</script>
